import { Call } from 'src/models';
import { useGetPractitionerList } from 'src/hooks/practitioner';
import { Select } from 'antd';
import { PractitionerName } from 'src/components';
import { useAssignCall } from 'src/hooks/call';
import { toast } from '@insight-health-ai/roseate/components';
import styled from '@emotion/styled';

type CallPractitionerProps = {
  call: Call;
};

const StyledSelect = styled(Select)`
  & .ant-select-selector {
    padding-left: 0 !important;
  }
`;

export const CallPractitioner = ({ call }: CallPractitionerProps) => {
  const { data: practitionerList, isLoading: isLoadingPractitionerList } =
    useGetPractitionerList({
      is_shown: true,
    });

  const { mutateAsync: assignCall, isPending: isAssigningCall } =
    useAssignCall();

  return (
    <StyledSelect
      loading={isAssigningCall}
      disabled={isAssigningCall}
      variant="borderless"
      value={call.assigned_to_practitioner_id || undefined}
      dropdownStyle={{ minWidth: 'fit-content' }}
      popupMatchSelectWidth={false}
      placeholder={<div className="text-gray-500">Unassigned</div>}
      labelRender={({ label }) =>
        isLoadingPractitionerList ? (
          <PractitionerName practitioner={call.assigned_to_practitioner!} />
        ) : (
          label
        )
      }
      options={practitionerList?.practitioners.map((practitioner) => ({
        label: <PractitionerName practitioner={practitioner} />,
        value: practitioner.practitioner_id,
        practitioner,
      }))}
      onChange={async (value) => {
        assignCall({
          callId: call.call_id,
          practitionerId: value as number,
        }).catch(() => {
          toast.error('Failed to assign call!');
        });
      }}
    />
  );
};
